import React, { Component } from 'react';
import { NavLink, Link } from 'react-router-dom'
import './Departments.css'
class DepartmentTable extends Component {
  render() {
    let { fetchedDepartments } = this.props
    var numbering = 0
    return (
      <div className="text-center md:text-left mt-4">
        <div className="w-full  h-full bg-white rounded-md">
          <table className="divide-y text-sm  border-b border-gray-200 divide-gray-200">
            <thead>
              <tr className="text-gray-500">
              <th className="  px-8 py-3 whitespace-nowrap  text-sm font-medium  ">
                                                    #
                                                </th>
                <th className="  px-4 py-3 whitespace-nowrap  text-sm font-medium  ">
                  Department Name
                </th>
                <th scope="col" className="  px-8 py-3 whitespace-nowrap  text-sm font-medium  ">
                  Department Description
                </th>
                <th scope="col" className="  px-8 py-3 whitespace-nowrap  text-sm font-medium  ">
                  Department Collections
                </th>
                <th scope="col" className=" px-24 py-3 whitespace-nowrap  text-sm font-medium  ">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {
                   fetchedDepartments.map(department=>{
                    numbering += 1
                     return(
                       <tr key={department.id} className="border-b border-gray-200 pt-4">
                         <td className="px-8 py-3 whitespace-nowrap  text-sm font-medium  ">
                          <span className="text-sm text-left">{numbering}</span>
                     </td>
                         <td  className="  px-4 py-3 whitespace-nowrap  text-sm font-medium  ">
                             <span className="text-sm text-left text-wvrblue">{department.title}</span>
                         </td>
                         <td  className="  px-8 py-3 whitespace-nowrap  text-sm font-medium  ">
                          <span className="text-sm text-left">{department.description}</span>
                        </td>
                        <td  className="  px-8 py-3 whitespace-nowrap text-left text-sm font-medium  ">
                          
                          <Link to={`departments/${department.id}`}>
                            <div className="flex text-wvrblue">
                              <div className="h-6 w-6 rounded-full bg-wvrSkyBlue flex justify-center items-center">
                              <svg className="w-4 h-3" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 6a2 2 0 012-2h5l2 2h5a2 2 0 012 2v6a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" /></svg>
                            
                              </div>
                            
                              <span className=" font-medium ml-2">
                                {department.collections_count} Collections
                              </span>
                            </div>
                         </Link>
                          
                        </td>
                     <td  className="  px-24 py-3 whitespace-nowrap  text-sm font-medium  ">
                       <div className="flex">
                       <Link to={`departments/${department.id}`} className="bg-wvrblue text-white p-1 ml-2 rounded-md">
                          <span className="ml-2 mr-2 font-thin">view</span>
                       </Link>
                        {/* <Link to="" className="bg-wvrPrimary p-1 ml-2 rounded-md">
                            <span className="ml-2 mr-2 font-thin">edit</span>
                        </Link>
                          <Link to="" className="text-wvrDarkPrimaryL p-1 ml-2">
                            <p><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash-2"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg></p>
                          </Link>  */}
                       </div>
                     </td>
                       </tr>
                     )
                   })
                 }

            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default DepartmentTable;